import React from 'react';
import Spinner from './BootstrapSpinner';

const RouteLoadingFallback = () => (
  <div className="d-flex justify-content-center align-items-center p-5">
    <Spinner style={{ color: '#f6c026' }} />
  </div>
);

export default RouteLoadingFallback;
